import React, { Component } from 'react';

class VersionFiles extends Component {  
    render() {
        let i = 0;
        return (
            <td>{this.props.files.map((file) => <a key={++i} href={file.name}>{file.label} </a>)}</td>
        );
    }
}

export default VersionFiles;